const images = new Map<string, HTMLImageElement>();

export const getCachedImage = (src: string): HTMLImageElement | null =>
  images.get(src) ?? null;

export const loadImage = (src: string): Promise<void> => {
  if (images.has(src)) return Promise.resolve();
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      images.set(src, img);
      resolve();
    };
    img.onerror = () => resolve();
    img.src = src;
  });
};
